<template>
    <div class="filters-item" v-if="data && data.length">
        <div class="filters-item-title" ref="title">
            <span class="title">{{title}}</span>
            <span class="all" v-if="all && showMore" :class="{active: more}" @click.stop="handleMore"><span>{{more ? collapseText : expandText}}</span><i v-if="!more" class="jc-icon icon-arrow-down"></i><i v-else class="jc-icon icon-arrow-up"></i></span>
        </div>
        <ul class="filter-items" ref="list" :style="{height: height + 'px'}">
            <li v-if="canAll" :class="{active: selectedAll, 'disabled': !multiple || !all}"  @click.stop="onSelectedAll">{{allText}}</li>
            <li v-for="(item, index) in data"
            :key="typeof item === 'object' ? item[valueKey] : index"
            :class="{active: values.findIndex(val => typeof item === 'object' ?  val.value === item[valueKey] : val.value === item) !== -1}"
             @click.stop="handleClick(item, $event)"><span>{{typeof item === 'object' ? item[labelKey] : item}}</span></li>
        </ul>
    </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { setTimeout } from 'timers'
export default {
  name: 'search-drawer-item',
  props: {
    name: { // 必填，唯一值
      type: [String, Number],
      required: true
    },
    all: { // 是否显示全选
      type: Boolean,
      default: true
    },
    allText: { // 全部字符
      type: String,
      default: '全部'
    },
    expandText: { // 更多字符
      type: String,
      default: '更多'
    },
    collapseText: {
      type: String,
      default: '收起'
    },
    title: { // 标题
      type: String,
      required: true,
      default: ''
    },
    data: { // 数据
      type: Array,
      required: true
    },
    valueKey: { // 当元素为对象时使用，指定选项的值的属性值
      type: String,
      default: 'id'
    },
    labelKey: { // 当元素为对象时使用，指定选项标签的属性值
      type: String,
      default: 'name'
    },
    defaultValues: { // 默认值：当设置为单选时，仅第一位有效
      type: Array,
      default () {
        return []
      }
    },
    independ: Boolean, // 是否和搜索结果联动，建议级联时设置
    multiple: { // 是否多选
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      init: false,
      more: false,
      values: [],
      height: 0,
      searchbar: null,
      selectedAll: false,
      showMore: false,
      sort: -1,
      oneHeight: 0,
      debounceTime: 0,
      canAll: false,
      timer: null,
      heightInit: false
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler () {
        this.__init()
      }
    },
    defaultValue () {
      this.__initValues()
    }
  },
  methods: {
    clearValues () {
      this.values = []
      this.selectedAll = false
      if (!this.independ) {
        this.searchbar.onChange(this.name, this.values)
      }
      this.$emit('change', this.name, this.values)
    },
    __init () {
      // if (this.init) return
      if (this.data && this.data.length > 0) {
        this.init = true
        this.$nextTick(() => {
          this.oneHeight = this.$refs.title ? this.$refs.title.scrollHeight : 0
          if (this.oneHeight > 0) this.heightInit = true
          this.height = this.oneHeight
          this.showMore = this.data.length >= 3
          this.canAll = this.data.length > 1 && this.multiple
          // 收起更多
          this.more = false
        })
        this.__initValues()
      }
    },
    __initValues () {
      if (!this.init) return
      // 设置默认值
      if (this.defaultValues && this.defaultValues.length && this.data) {
        if (!this.multiple) {
          // 处理单选，第一位有效
          let val = this.defaultValues[0]
          if (typeof val === 'object') {
            if (this.data.findIndex(item => item[this.valueKey] === val[this.valueKey]) !== -1) {
              this.values.push({
                value: val[this.valueKey],
                label: val[this.labelKey],
                payload: {
                  ...val
                }
              })
            }
          } else {
            if (this.data && this.data.findIndex(item => item === val) !== -1) {
              this.values.push({
                value: val,
                label: val,
                payload: {
                  ...val
                }
              })
            }
          }
          return
        }
        this.defaultValues.forEach(val => {
          if (typeof val === 'object') {
            if (this.data.findIndex(item => item[this.valueKey] === val[this.valueKey]) !== -1) {
              this.values.push({
                value: val[this.valueKey],
                label: val[this.labelKey],
                payload: {
                  ...val
                }
              })
            }
          } else {
            if (this.data && this.data.findIndex(item => item === val) !== -1) {
              this.values.push({
                value: val,
                label: val,
                payload: {
                  ...val
                }
              })
            }
          }
        })
        if (!this.independ) this.searchbar.onChange(this.name, this.values)
        this.$emit('change', this.name, this.values)
      }
    },
    __initListHeight () {
      return this.$refs.list.scrollHeight
    },
    initHeight () {
      setTimeout(() => {
        if (this.$refs.title && !this.heightInit) {
          this.oneHeight = this.$refs.title ? this.$refs.title.scrollHeight : 0
          this.height = this.oneHeight
          if (this.oneHeight > 0) this.heightInit = true
        }
      }, 20)
    },
    handleClick (item, $event) {
      // let target = $event.currentTarget
      if (this.multiple) {
        let index = this.values.findIndex(value => typeof item === 'object' ? value.value === item[this.valueKey] : value.value === item)
        if (index !== -1) {
          this.values.splice(index, 1)
        } else {
          this.values.push({
            value: typeof item === 'object' ? item[this.valueKey] : item,
            label: typeof item === 'object' ? item[this.labelKey] : item,
            payload: {
              ...item
            }
          })
        }
        if (this.values.length !== this.data.length) this.selectedAll = false
        else this.selectedAll = true
      } else {
        if (this.values.length && typeof item === 'object' && this.values[0].value === item[this.valueKey]) return
        else if (this.values.length && this.values[0].value === item) return
        this.values = []
        this.$set(this.values, 0, {
          value: typeof item === 'object' ? item[this.valueKey] : item,
          label: typeof item === 'object' ? item[this.labelKey] : item,
          payload: {
            ...item
          }
        })
      }
      this.emitChange()
    },
    __emitChange () {
      if (!this.independ) this.searchbar.onChange(this.name, this.values)
      this.$emit('change', this.name, this.values)
    },
    onSelectedAll () {
      if (!this.multiple) return
      this.selectedAll = !this.selectedAll
      if (this.selectedAll) {
        this.values = []
        this.data.forEach(item => {
          this.values.push({
            value: typeof item === 'object' ? item[this.valueKey] : item,
            label: typeof item === 'object' ? item[this.labelKey] : item,
            payload: {
              ...item
            }
          })
        })
      } else {
        this.values = []
      }
      // if (!this.independ) this.searchbar.onChange(this.name, this.values)
      this.emitChange.cancel()
      this.emitChange()
    },
    onChangeModel () {
      this.multiple = !this.multiple
    },
    handleMore () {
      this.more = !this.more
      if (this.more) {
        this.height = this.__initListHeight()
      } else {
        this.height = this.$refs.list.children.length ? this.$refs.list.children[0].scrollHeight : 0
      }
    }
  },
  created () {
    this.emitChange = debounce(this.__emitChange, this.debounceTime, {maxWait: 1 * this.debounceTime + 0.5 * this.debounceTime, leading: false, trailing: true})
  },
  beforeMount () {
    if (!this.independ) {
      this.searchbar = this.$parent.$parent
      this.sort = this.searchbar.items.length
      this.searchbar.items.push(this)
    }
    this.__init()
  },
  mounted () {
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/search-drawer/drawer-item.vue